import { createFileRoute } from "@tanstack/react-router";

import {
  ConsoleFlowsPage,
  consoleFlowTemplatesQueryOptions,
  consoleFlowsQueryOptions,
  consolePendingApprovalsQueryOptions,
} from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/flows/")({
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleFlowsQueryOptions());
    // Warm the gallery — the section is one click away (and auto-opens on
    // an empty project).
    void queryClient.ensureQueryData(consoleFlowTemplatesQueryOptions());
    // The "Approvazioni" tab badge counts from this cache.
    void queryClient.ensureQueryData(consolePendingApprovalsQueryOptions());
  },
  component: ConsoleFlowsPage,
});
